import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../../common/createSxStyles";

export const useSubProcessorStepStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        subProcessorContainer: {
            position: "relative",
            textAlign: "center",
            padding: theme.spacing(3),
        },
        exclamation: {
            position: "absolute",
            right: theme.spacing(-8.125),
            top: theme.spacing(1),
        },
        exclamationIcon: {
            fill: theme.palette.error.main,
        },
    });
};
